import * as React from "react"

import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconDot = ({
  title = "Dot",
  color = "gray",
  viewBoxWidth = 3,
  viewBoxHeight = 3,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <circle
      cx="493.5"
      cy="945.5"
      r="1.5"
      transform="translate(-492 -944)"
      fill={uiColorToBaseColor(color)}
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconDot
